module.exports = __webpack_public_path__ + "7bb265b0481aeb56130e53db83b2adf7.png";